<svelte:options runes={false} />
<script>
  // The CURRENT US $100 note (Series 2009 redesign) for the Live-trading header. This is a real public-domain
  // image of the note (a work of the U.S. Government — Bureau of Engraving and Printing — ineligible for US
  // copyright), bundled via Vite so it is content-hashed at build. No "FAKE" watermark — this is the Live
  // (real money) view. Source: Wikimedia Commons, File:USA_100_Dollar_Bill_Series2009_Obverse.png.
  import billUrl from '../../lib/assets/us-100-dollar-bill.png';

  export let height = 44; // px; width follows the note's 896×378 (~2.37:1) aspect ratio.
  $: width = Math.round((height * 896) / 378);
</script>

<img class="real-bill" src={billUrl} alt="US one hundred dollar bill" {width} {height} draggable="false" />

<style>
  .real-bill {
    display: inline-block;
    vertical-align: middle;
    border-radius: 4px;
    flex: none;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
    object-fit: cover;
  }
</style>
